import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { Loader2 } from 'lucide-react';

const LoadingFallback = ({ message = 'Loading...' }) => {
  const { theme } = useTheme();
  
  return (
    <div 
      className="flex items-center justify-center min-h-screen"
      style={{ background: theme.background }}
    >
      <div className="text-center">
        <Loader2 
          className="w-12 h-12 animate-spin mx-auto mb-4" 
          style={{ color: theme.primary }}
        />
        <p style={{ color: theme.textSecondary }}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
